import React, { useState } from "react";
import styles from './styles.module.css'
import Title from '../../components/Title'
import TextInput from '../../components/TextInput'
import Button from '../../components/Button'
import ButtonOutline from '../../components/ButtonOutline'
import colors from '../../colors.js'
import { useNavigate } from "react-router-dom";
import { registerWithEmailAndPassword } from "../../firebase";
import PasswordInput from "../../components/PasswordInput";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errMsg, setErrMsg] = useState(false);
  const navigate = useNavigate();

  const register = () => {
    if (!firstName || !lastName || !email || !password) {
      setErrMsg("All fields are required");
      return; 
    }
    if (password !== repeatPassword) {
      setErrMsg("Passwords do not match");
      return;
    }
    registerWithEmailAndPassword(firstName, lastName, email, password, setErrMsg);
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      register();
    }
  };

  return (
    <div className={styles.loginContainer}>
        <div className={styles.logoContainer}>
            <img className={styles.logoImg} src='logo.png' alt="RENR logo (leaf)"/>
            <Title>Welcome to RENR Safety App</Title>
        </div>
        <div className={styles.loginForm} onKeyDown={handleKeyDown}>
            <TextInput label={'First name'} setText={setFirstName} name={'firstName'} />
            <TextInput label={'last name'} setText={setLastName} name={'lastName'}/>
            <TextInput label={'email'} setText={setEmail} type='email' name={'email'}/>
            <PasswordInput label={'Password'} setText={setPassword} name={'password'}/>
            <PasswordInput label={'Repeat Password'} setText={setRepeatPassword} name={'repeatPassword'}/>
            {errMsg && <p className={styles.errMsg}>{errMsg}</p>}
            <div className={styles.buttonGroup}>
              <Button color={colors.green} onClick={register}>Sign Up</Button>
              <ButtonOutline color={colors.green} onClick={()=>navigate('/login')}>Log In</ButtonOutline>
            </div>
        </div>
    </div>
  )
}

export default Login